<dx-select-box
  [dataSource]="dataSource"
  [value]="selectedKey"
  [grouped]="true"
  valueExpr="key"
  displayExpr="label"
  [searchEnabled]="true"
  [showClearButton]="showClearButton"
  [disabled]="disabled"
  [placeholder]="placeholder"
  class="gpd-input"
  itemTemplate="holderTemplate"
  (onValueChanged)="onValueChanged($event)"
>
  <div *dxTemplate="let data of 'holderTemplate'">
    <div class="holder-item">
      <app-user-avatar *ngIf="data.kind === 'user'" [userEmail]="data.email" [size]="24"></app-user-avatar>
      <app-svg-icon *ngIf="data.kind === 'department'" icon="user-multiple" [size]="20" color="var(--color-primary)"></app-svg-icon>
      <span>{{ data.label }}</span>
    </div>
  </div>
</dx-select-box>
